module.exports = __webpack_public_path__ + "static/one-e6bc2a8436e796a2ba63837670570495.png";